import React, { useCallback } from 'react';
import {
	ApButtonSecondary,
	ApIcon,
	ApLoaderDefault,
	ApLoaderText,
	ApSimpleDropdown,
} from '@alixpartners/ui-components';
import Highcharts from 'highcharts';
import {
	ExploreButton,
	Header,
	LoadingContainer,
	NoData,
	SectionWrapper,
	Title,
} from './ChartList.styles';
import HighchartsReact from 'highcharts-react-official';
import { useRef } from 'react';
import { useState } from 'react';
import { renderToString } from 'react-dom/server';
import Tooltip from '../../Components/Tooltip';
import { Tooltip as RangeTooltip } from 'react-tippy';

import { useFilterContext } from 'contexts/FilterContext';
import CategoryMultiSelect from 'Settings/FirstUsageSettings/CategoryMultiSelect';
import {
	MultiSelectWrapper,
	RangeWrapper,
	SpendWrapper,
} from '../../WidgetSettings.js/WidgetSettings.styles';
import filterNames, { spendFormatter } from 'utils/filterNames';
import { TooltipContent } from '../../CategoryWidget.styles';
import Slider from 'rc-slider';
import { useChartContext } from 'contexts/CategoryChartContext';
import ExpandedModal from '../../Components/ExpandedModal';

const ScatterPlot = ({
	chartTitle,
	isParent,
	chartheight,
	chartData,
	chartWidth,
}) => {
	const [isExpandedView, setIsExpandedView] = useState(false);
	const chartRef = useRef();
	const { state: newState, actions } = useFilterContext();

	const initialScatterPlotSettings = {
		[filterNames.scatterPlotState]: newState.scatterPlotState,
		[filterNames.scatterPlotWorkerType]: newState.scatterPlotWorkerType,
		[filterNames.scatterPlotCagr]: newState.scatterPlotCagr,
	};
	const { setMultipleFilters } = actions;
	const { state } = useChartContext();
	const { scatterplotLoading } = state;

	const [scatterPlotTEmp, setScatterplotTEmp] = useState(
		newState.scatterPlotEmpTotalRange
	);
	const [scatterPlotSettings, setScatterPlotSettings] = useState(
		initialScatterPlotSettings
	);

	const handleChange = useCallback((evnt, action, chart) => {
		if (action === 'state' && chart === 'scatter') {
			setScatterPlotSettings(prev => ({
				...prev,
				[filterNames.scatterPlotState]: evnt,
			}));
		}
		if (action === 'workerType' && chart === 'scatter') {
			setScatterPlotSettings(prev => ({
				...prev,
				[filterNames.scatterPlotWorkerType]: evnt,
			}));
		}
		if (action === 'cagr' && chart === 'scatter') {
			setScatterPlotSettings(prev => ({
				...prev,
				[filterNames.scatterPlotCagr]: evnt,
			}));
		}
	}, []);

	const options = {
		chart: {
			type: 'scatter',
			height: chartheight,
			width: chartWidth,
			zoomBySingleTouch: true,
			zoomType: 'xy',
		},
		exporting: { enabled: false, allowHTML: true },
		credits: { enabled: false },
		title: { text: '' },
		boost: {
			useGPUTranslations: true,
		},

		legend: {
			enabled: false,
		},
		xAxis: {
			title: {
				text: 'Hourly pay',
			},
			labels: {
				formatter: function() {
					return spendFormatter(this.value, true);
				},
			},
			startOnTick: true,
			endOnTick: true,
			showLastLabel: true,
			gridLineWidth: 0,
		},
		yAxis: {
			title: {
				text: 'CAGR',
			},
			endOnTick: false,
			maxPadding: 0.1,
			gridLineWidth: 0,
			lineWidth: 1,
			labels: {
				format: '{value}%',
			},
		},

		plotOptions: {
			series: {
				animation: false,
				shadow: false,
			},
			scatter: {
				states: {
					hover: {
						marker: {
							enabled: false,
						},
					},
				},
				jitter: {
					x: 0.005,
				},
			},
		},
		series: [
			{
				name: 'Series 1',
				data: chartData,
			},
		],
		animation: false,
	};

	return (
		<SectionWrapper>
			<Header>
				<Title>{chartTitle}</Title>
				{isParent && (
					<ExploreButton
						title="Explore"
						className="explore"
						onClick={() => setIsExpandedView(true)}
					>
						<ApIcon title="Explore" material={true} iconName="find_in_page" />
					</ExploreButton>
				)}
			</Header>
			{!isParent && (
				<div style={{ display: 'flex' }}>
					<MultiSelectWrapper>
						<CategoryMultiSelect
							name="States"
							label="Select State"
							options={newState.stateOptions}
							selected={scatterPlotSettings.scatterPlotState}
							onChange={e => handleChange(e, 'state', 'scatter')}
						/>
					</MultiSelectWrapper>
					<MultiSelectWrapper>
						<CategoryMultiSelect
							name="States"
							label="Worker Type"
							options={newState.workerTypeOptions}
							selected={scatterPlotSettings.scatterPlotWorkerType}
							onChange={e => handleChange(e, 'workerType', 'scatter')}
						/>
					</MultiSelectWrapper>
					<ApSimpleDropdown
						onChange={e => handleChange(e, 'cagr', 'scatter')}
						options={newState.cagrOptions}
						selected={scatterPlotSettings.scatterPlotCagr}
						label="CAGR"
					/>
					<SpendWrapper>
						<span>Total Employees</span>
						<RangeWrapper>
							<RangeTooltip
								position="top"
								animation="fade"
								theme="light"
								arrow
								trigger="mouseenter"
								html={
									<TooltipContent>
										<span>Lower:</span>
										{scatterPlotTEmp[0]}
										{/* <br /> */} &nbsp;
										<span>Upper:</span> {scatterPlotTEmp[1]}
									</TooltipContent>
								}
								popperOptions={{
									modifiers: {
										preventOverflow: {
											enabled: true,
											boundariesElement: 'window',
										},
									},
								}}
							>
								<Slider
									range
									defaultValue={newState.scatterPlotEmpTotalRange}
									min={newState.totalEmpRange[0]}
									max={newState.totalEmpRange[1]}
									allowCross={false}
									draggableTrack={false}
									value={scatterPlotTEmp}
									onChange={e => {
										setScatterplotTEmp(e);
										handleChange(e, 'totalemp', 'scatter');
									}}
								/>
							</RangeTooltip>
						</RangeWrapper>
					</SpendWrapper>
					<ApButtonSecondary
						onClick={() => {
							const obj = {};
							console.log(scatterPlotSettings);
							for (const key in scatterPlotSettings) {
								if (
									Array.isArray(scatterPlotSettings[key]) ||
									scatterPlotSettings[key].length > 0 ||
									scatterPlotSettings.scatterPlotCagr
								) {
									obj[key] = scatterPlotSettings[key];
								}
							}
							setMultipleFilters({
								...obj,
								[filterNames.scatterPlotEmpTotalRange]: scatterPlotTEmp,
							});
						}}
						style={{ marginLeft: 'auto' }}
					>
						Save
					</ApButtonSecondary>
				</div>
			)}
			{scatterplotLoading === true ? (
				<LoadingContainer>
					<ApLoaderDefault loaderText={() => <ApLoaderText />} />
				</LoadingContainer>
			) : (
				<>
					{chartData.length === 0 ? (
						<NoData>No data available</NoData>
					) : (
						<>
							<HighchartsReact
								highcharts={Highcharts}
								options={{
									...options,
									tooltip: {
										shared: true,
										useHTML: true,
										backgroundColor: 'rgba(255,255,255, 0.9)',
										borderWidth: 0,
										borderRadius: 2,
										outside: true,
										formatter: function() {
											const { point } = this;
											return renderToString(
												<Tooltip
													tooltipData={point?.tooltip}
													color={point?.color}
												/>
											);
										},
									},
								}}
								ref={chartRef}
							/>
						</>
					)}
					{isExpandedView && (
						<ExpandedModal
							heading={chartTitle}
							show={true}
							handleClose={() => setIsExpandedView(state => !state)}
						>
							<ScatterPlot chartheight={'30%'} chartData={chartData || []} />
						</ExpandedModal>
					)}
				</>
			)}
		</SectionWrapper>
	);
};

export default React.memo(ScatterPlot);
